// eslint-disable-next-line no-underscore-dangle
var _routerLink = null;
export var routerLink = {
    get Component() {
        return _routerLink;
    },
    set Component(component) {
        _routerLink = component;
    },
};
export var setupRouterLink = function (component) {
    routerLink.Component = component;
};
